import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Kayan duyuru bandı — Shadow DOM (@keyframes global çakışmasın).
 * source='announcement' Faz 2'de Gateway'den alınır; MVP'de custom text.
 */
@customElement('fp-marquee')
export class FpMarquee extends LitElement {
    @property({ type: String }) source: 'announcement' | 'custom' = 'custom';
    @property({ type: String }) text = '';
    @property({ type: Number }) speed = 50;
    /** Yazı boyutu: auto=1 / large=1.25 / xlarge=1.5 (--fp-marquee-scale). */
    @property({ type: String }) textSize: 'auto' | 'large' | 'xlarge' = 'auto';

    static styles = css`
        :host {
            display: block;
            width: 100%;
            overflow: hidden;
            background: var(--fp-surface, var(--fp-color-surface));
            color: var(--fp-color-fg);
            padding: 0.5em 0;
            border-top: 1px solid color-mix(in srgb, var(--fp-color-fg-muted) 20%, transparent);
            /* Duyuru yazısı ekran yüksekliğine oranlı (TV'de okunur) + Yazı boyutu çarpanı. */
            font-size: clamp(15px, calc(2.8vh * var(--fp-marquee-scale, 1)), 64px);
        }
        .track {
            display: inline-flex;
            white-space: nowrap;
            animation-name: scroll;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            will-change: transform;
        }
        .seg {
            padding-right: 4rem;
        }
        /* İçerik iki kez render → -50% kaydırma dikişsiz döner (boş bant yok) (O12). */
        @keyframes scroll {
            from { transform: translateX(0); }
            to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
            .track { animation: none; }
        }
    `;

    render() {
        const scale = this.textSize === 'large' ? 1.25 : this.textSize === 'xlarge' ? 1.5 : 1;
        this.style.setProperty('--fp-marquee-scale', String(scale));
        const displayText = this.text || (this.source === 'announcement' ? 'Duyurular yükleniyor...' : '');
        if (!displayText) return html`<div class="track"></div>`;
        // Süre metin uzunluğuna göre ölçeklenir (uzun metin daha yavaş → okunaklı).
        const duration = Math.max(12, (displayText.length * 0.35 * 100) / Math.max(1, this.speed));
        return html`
            <div class="track" style="animation-duration: ${duration}s;">
                <span class="seg">${displayText}</span><span class="seg">${displayText}</span>
            </div>
        `;
    }
}
